// Action types
import * as actionTypes from "../actionTypes/chat.types";

export const setNewChatMessage = message => {
  return {
    type: actionTypes.SET_CHAT_NEW_MESSAGE,
    message
  };
};
